<template>
  <div id="home_top_base">
    <div id="home_top_main">
      <div id="home_top_nav">
        <ul id="home_top_nav_ul">
          <li>
            <router-link to="/" class="nav1" id="home_top_logo">5biji</router-link>
          </li>
          <li>
            <router-link to="/" class="nav1" id="nav1_index">首页</router-link>
          </li>
          <li>
            <router-link to="/help" class="nav1" id="nav1_help">新手帮助</router-link>
          </li>
          <!-- <li>
            <router-link to="/gather" class="nav1" id="nav1_gather">流量统计</router-link>
          </li> -->
          <li>
            <a href="/s/diary/search.html" class="nav1" id="">查找文档</a>
          </li>
          <li v-if="isOutNet==1">
            <a href="http://124.223.201.107:81/" class="nav1" id="menu_neiwang">国内地址（速度快）</a>
          </li>
        </ul>
      </div>
      <div id="home_top_btn">
        <ul id="home_top_btn_ul">
          <li>
            <template v-if="userName==''">
              <router-link to="/login" class="nav1" id="nav1_login">登录</router-link>
            </template>
            <template v-else>
              <a href="../../home/desktop/index.html" class="nav1" target="_self">进入系统</a>
            </template>
          </li>
          <li>
            <router-link to="/regist" class="nav1" id="nav1_regist">注册</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import gConfig from '../gConfig';

export default {
  name: 'Menu1',
  data() {
    return {
      isOutNet: 0,
      msg: '这是Menu1组件',
      userName: ''
    }
  },
  methods: {
    checkLocation: function () {
      var h = window.location.href;
      if (h.indexOf('5biji.com') > 0) {
        this.isOutNet = 1;
      }
    },
    checkSession: function() {
      var self = this;
      axios.post(gConfig.web_pc + '/home/IndexMain/checkSession', {
          firstName: 'Fred',
          lastName: 'Flintstone'
      }).then(function (response) {
          self.userName = response.data.msg;
      }).catch(function (error) {
          console.log(error);
      });
    }
  },
  mounted: function () {
    this.checkLocation();
    this.checkSession();
  }
}
</script>

<style>
@import '../assets/homeContent/menu.css';
</style>



// WEBPACK FOOTER //
// src/components/Menu1.vue